/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Box,
  Drawer,
  Hidden,
  List,
  Link,
  makeStyles,
  Typography
} from '@material-ui/core';
import Logo from 'src/components/Logo';
import NavItem from './NavItem';
import Manual from 'src/assets/files/manual.pdf';
import { useTranslation } from 'react-i18next';

function renderNavItems({ items, ...rest }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, ...rest }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({ acc, item, depth = 0 }) {
  if (item.items) {
    acc.push(
      <NavItem depth={depth} key={item.href} title={item.title}>
        {renderNavItems({
          depth: depth + 1,
          items: item.items
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        key={item.href}
        title={item.title}
      />
    );
  }

  return acc;
}

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  }
}));

function NavBar({ openMobile, onMobileClose }) {
  const classes = useStyles();
  const location = useLocation();
  const { t } = useTranslation('common');

  const navItems = [
    {
      title: t('welcomeTitle'),
      href: '/docs/welcome'
    },
    {
      title: t('gettingStartedTitle'),
      href: '/docs/getting-started'
    },
    {
      title: t('adminDashboardTitle'),
      href: '/docs/admin'
    },
    {
      title: t('studioDashboardTitle'),
      href: '/docs/studio'
    },

    {
      title: t('humanHelpTitle'),
      href: '/docs/human-help'
    },

    {
      title: t('actionsTitle'),
      href: '/docs/actions'
    },
    {
      title: t('messagesTitle'),
      href: '/docs/Messages'
    },
    {
      title: t('settingsTitle'),
      href: '/docs/settings'
    },

    {
      title: t('nluConfigTitle'),
      href: '/docs/nlu-config'
    },

    {
      title: t('channelsRestrictionsTitle'),
      href: '/docs/channels-restrictions'
    },
    {
      title: t('channelsConfiguraationTitle'),
      href: '/docs/channels-config'
    },
    // {
    //   title: 'Authentication',
    //   href: '/docs/authentication'
    // },

    {
      title: t('changelogTitle'),
      href: '/docs/changelog'
    }
  ];
  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  const content = (
    <Box height='100%' display='flex' flexDirection='column'>
      <Hidden lgUp>
        <Box p={2}>
          <RouterLink to='/'>
            <Logo />
          </RouterLink>
        </Box>
      </Hidden>
      <Box p={2}>{renderNavItems({ items: navItems })}</Box>
      <Box p={2}>
        <Box p={2} borderRadius='borderRadius' bgcolor='background.dark'>
          <Typography variant='h6' color='textPrimary'>
            {t('help')}
          </Typography>
          <Link
            variant='subtitle1'
            color='secondary'
            href={Manual}
            target='_blank'
            download
          >
            {t('downloadManual')}
          </Link>
        </Box>
      </Box>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor='left'
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant='temporary'
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor='left'
          classes={{ paper: classes.desktopDrawer }}
          open
          variant='persistent'
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default NavBar;
